/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-09T17:00:10.546
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentRepairFeedbackCall,
	listRentRepairFeedbackCallInit,
	listRentRepairFeedbackCallByAuthorizations,
	deleteRentRepairFeedbackCall
} from '@api/rentmanage/RentRepairFeedbackCall';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentRepairFeedbackCall({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackCall(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentRepairFeedbackCallByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackCallByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentRepairFeedbackCallInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackCallInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentRepairFeedbackCall({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentRepairFeedbackCall({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
